import { render, staticRenderFns } from "./TabunganAnggota.vue?vue&type=template&id=0394ad7c"
import script from "./TabunganAnggota.vue?vue&type=script&lang=js"
export * from "./TabunganAnggota.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports